var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedgeHtml({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.994,
    height: 12,
    viewBox: "0 0 11.994 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93339",
    "data-name": "Path 93339",
    d: "M11.983,4.837c0-.44-.035-.879-.048-1.319-.005-.174-.007-.35-.022-.525-.035-.419-.043-.839-.063-1.259-.011-.23-.035-.458-.032-.689a.755.755,0,0,0-.044-.265.858.858,0,0,0-.856-.6c-.249,0-.5-.024-.747-.032C9.986.142,9.8.141,9.612.125,9.2.092,8.788.083,8.377.063,8.128.052,7.879.039,7.63.029,7.4.022,7.178.035,6.953.008a1.056,1.056,0,0,0-.92.376Q3.176,3.26.3,6.119a.836.836,0,0,0-.3.57v.164c.024.035.007.076.012.113a.73.73,0,0,0,.278.507q2.116,2.121,4.237,4.238A.808.808,0,0,0,5.078,12h.234a.793.793,0,0,0,.545-.279L11.7,5.873l.05-.05a.8.8,0,0,0,.239-.6c0-.129-.011-.257-.01-.386M9.577,3.39a.962.962,0,1,1,.956-.961.967.967,0,0,1-.956.961",
    transform: "translate(0 0)",
    fill: "#7f67db"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedgeHtml);
export default __webpack_public_path__ + "static/media/bedge-html.31bffa61bd1967c9e0105724a4407b16.svg";
export { ForwardRef as ReactComponent };